/**
 * Generated bundle index. Do not edit.
 */

export {NgxJsonViewerModule,NgxJsonViewerComponent} from './index';
